module.exports = __webpack_public_path__ + "img/zx4.93bf74b5.png";